(function CruiseSearchView($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/CruiseSearch/view', function onload()
		{
			var $deckplans = $("#deck-plans");

			/*
				when a deck plan is clicked, open the modal window with it's contents
			 */
			$deckplans.on('click', '.deck', function loadDeck(e) {
				var $deck      = $(this),
				    $image_url = $deck.children(".image-url").val(),
				    $label     = $.trim($deck.children(".deck-title").text());

				$(".modal-title").text($label);
				$(".modal-body").html("<img src='" + $image_url + "'>");
			});

			$('.enlarge').click(function _enlarge(e) {
				var $image_url = $(this).data('image');

				if (typeof $image_url !== 'undefined') {
					$(".modal-title").text('Image Viewer');
					$(".modal-body").html("<img src='" + $image_url + "' style='max-height:650px'>");
					$('.modal').modal('show');
				}
			});

			$('.city-details').click(function cityClicked(e) {
				var $self    = $(this),
				    $city_id = $self.data("id");

				e.preventDefault();

				$(".modal-body").html('');

				Adzuki.Ajax.get('/Cities/view/' + $city_id)
					.then(function populateModal(content) {
						$(".modal-title").text('City Details');
						$('.modal-body').html(content);
						$('#modalLabel').html($self.data("name"));
				});

				$('.modal').modal('show');
			});

			$('.sailing-comparison-add').click(function addToComparison(e) {
				var $itinerary_id = $(this).data('id');

				e.preventDefault();

				document.location = Adzuki.base_uri + '/CruiseSearch/addToCompare/' + $itinerary_id;
			});

			$('.sailing-comparison-remove').click(function removeFromComparison(e) {
				var $itinerary_id = $(this).data('id');

				e.preventDefault();

				document.location = Adzuki.base_uri + '/CruiseSearch/removeFromCompare/' + $itinerary_id;
			});

			$('.consumer-url-copy').click(function doUrlCopy(e) {
				var copyText   = $(this).data('consumer-url');
				const textArea = document.createElement("textarea");

				e.preventDefault();

				textArea.value = copyText;
				document.body.appendChild(textArea);
				textArea.focus();
				textArea.select();

				try {
					document.execCommand('copy');
				} catch (err) {
					console.error('Unable to copy to clipboard', err);
				}

				document.body.removeChild(textArea);
			});
		}, false);
	});

	// custom functions
}(jQuery, window.Adzuki || {}));
